import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const vehicleViewModule = {
        isLoading: false,
        init() {
            $(document).on('click', '.broker-show-agent-phone', this, this.showPhoneNumber);
            $(document).on('click', '.vehicle-lead-send-btn', this, this.send);
        },
		showPhoneNumber(event) {
			const _this = event.data;
			event.preventDefault();

            var phone = $(this).data('text');
            $(this).find('span').text(phone);
            $(this).attr('href', 'tel:'+phone);
            $(this).removeClass('broker-show-agent-phone');
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();
            var element = this;

            var id = $(element).data('id');
            if (!id) {
                Swal.fire({
                    text: 'Invalid item ID!'
                });
                return false;
            }

            $('.item-lead-form').find('.form-control').removeClass('is-invalid');
            $('.item-lead-form').find('.form-check-input').removeClass('is-invalid');
            
            var errors = false;

            if ($('#item_lead_name').val() == '') {
                $('#item_lead_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#item_lead_email').val() == '') {
                $('#item_lead_email').addClass('is-invalid');
                errors = true;
            }
            if ($('#item_lead_phone').val() == '') {
                $('#item_lead_phone').addClass('is-invalid');
                errors = true;
            }
            if (!$('#item_lead_terms_and_conditions').is(":checked")) {
                $('#item_lead_terms_and_conditions').addClass('is-invalid');
                errors = true;
            }

            if (errors) {
                return false;
            }

            //Loading...
            _this.isLoading = true;
			$(element).find('i').show();

            var values = '_token=' + $('meta[name="csrf-token"]').attr("content");
            values += '&id=' + id;
            values += '&name=' + $('#item_lead_name').val();
            values += '&email=' + $('#item_lead_email').val();
            values += '&phone=' + $('#item_lead_phone').val();
            values += '&company=' + $('#item_lead_company').val();
            values += '&message=' + $('#item_lead_message').val();
            values += '&newsletter=' + ($('#item_lead_newsletter').is(":checked")?1:0);
            $.ajax({
                type: "POST",
                url: baseURL + "/vehicle/lead",
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#item_lead_"+errorKey).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }

                        Swal.fire({
                            html: response.message+"<br>"+errorHtml
                        });

                        return false;
                    }

                    if (response.status == 1) {

                        $('.item-lead-form').find('.form-control').val('');
                        $('.item-lead-form').find('.form-check-input').attr('checked', false);

                        Swal.fire({
                            text: response.message
                        });

                        return;
                    }

                    Swal.fire({
                        text: response.message
                    });
                },
                error: function() {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                }
            });

		}
    };

    if ($('.vehicles-page-container').length) {
        vehicleViewModule.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/vehicle_view.js